module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/fonts.json
// module id = 479
// module chunks = 248795187064286